<div class="comment-form">
  <div class="cover" *ngIf="(me$ | async) && (me$ | async).is_guest" (click)="authorize()"></div>
  <div class="input-group">
    <div class="form-contour">
      <label class="input-group">
        <!--Hide for now - https://app.clickup.com/t/85zt94ca8-->
<!--        <app-icon class="clip-icon" icon="clip"></app-icon>-->
        <input [(ngModel)]="new_comment"
               [disabled]="submitting"
               type="text" name="comment"
               class="input normal"
               placeholder="{{ 'comments.new-comment-placeholder' | customLocale }}"
               (keydown.enter)="submit()">
      </label>
    </div>
    <button class="submit-btn"
            [class.animation]="animating"
            [disabled]="submitting"
            aria-label="Submit"
            (click)="submit()">
      <app-icon class="submit-icon" [class.active]="new_comment.length > 0" width="24" height="23" icon="comment-submit"></app-icon>
    </button>
  </div>
</div>
